import LocalHeader from './LocalHeader'

export default LocalHeader
